<template>
  <div>
    <v-row>
      <v-col cols="12" md="3" lg="2">
        <h3>Name</h3>
        <v-text-field
          v-model="employee.Login"
          :readonly="!editMode"
          :rules="editMode ? [...rules.required, ...rules.noSpaces] : []"
        >
          <template v-slot:label>
            Login
            <span v-if="!employee.Login" class="error--text">*</span>
          </template>
        </v-text-field>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="employee.Name"
              :readonly="!editMode"
              :rules="editMode ? [...rules.required, ...rules.noSpaces] : []"
            >
              <template v-slot:label>
                First Name
                <span v-if="!employee.Name" class="error--text">*</span>
              </template>
            </v-text-field>
            <v-text-field
              v-model="employee.Last_Name"
              :readonly="!editMode"
              :rules="editMode ? [...rules.required, ...rules.noSpaces] : []"
            >
              <template v-slot:label>
                Last Name
                <span v-if="!employee.Last_Name" class="error--text">*</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Ім'я"
              v-model="employee.Name_UA"
              :readonly="!editMode"
            ></v-text-field>
            <v-text-field
              label="Прізвище"
              v-model="employee.Last_Name_UA"
              :readonly="!editMode"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="2" lg="1">
        <h3>Home</h3>
        <v-text-field
          label="Zip"
          v-model="employee.ZIP"
          :readonly="!editMode"
        ></v-text-field>
        <v-text-field
          label="City"
          v-model="employee.City"
          :readonly="!editMode"
        ></v-text-field>
        <v-text-field
          label="Country"
          v-model="employee.Address"
          :readonly="!editMode"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4" lg="3">
        <h3>Position</h3>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="status"
              readonly
              v-if="employee.Employee_ID"
            >
              <template v-slot:append>
                <v-btn
                  class="pa-0"
                  small
                  text
                  plain
                  :disabled="((officeManager || executiveAssistant) && !currentEmployee) || ((officeManager || executiveAssistant) && (currentEmployee && editMode))"
                  color="primary"
                  @click.prevent="showStatusHistory = true"
                >
                  ...
                </v-btn>
              </template>
            </v-text-field>
            <v-select
              v-if="editMode"
              label="Supervisor"
              :items="employeeList"
              item-text="full_name"
              item-value="employee_id"
              v-model="employee.Supervisor_ID"
            >
              <template v-slot:prepend-item>
                <div class="px-2">
                  <v-text-field
                    label="Search employee"
                    v-model="searchEmployee"
                  ></v-text-field>
                </div>
              </template>
            </v-select>
            <v-text-field
              v-else
              label="Supervisor"
              v-model="employee.Supervisor_Full_Name"
              readonly
            ></v-text-field>
            <v-select
              v-if="editMode"
              label="Mentor"
              :items="employeeList"
              item-text="full_name"
              item-value="employee_id"
              v-model="employee.Mentor_ID"
              clearable
            >
              <template v-slot:prepend-item>
                <div class="px-2">
                  <v-text-field label="Search mentor" v-model="searchEmployee"></v-text-field>
                </div>
              </template>
            </v-select>
            <v-text-field
              v-else
              label="Mentor"
              v-model="employee.Mentor_Full_Name"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <DatePicker
              v-if="editMode"
              v-model="hiringDate"
              label="Hiring Date"
              details
            />
            <v-text-field
              v-else
              label="Hiring Date"
              v-model="hiringDate"
              readonly
            ></v-text-field>
            <DatePicker
              v-if="editMode"
              v-model="trialPeriodEndDate"
              label="Trial Period End Date"
              :rules="!employee.Employee_ID ? rules.required : []"
              details
              @onDatePickerChange="saveTrialPeriodEndDate"
            />
            <v-text-field
              v-else-if="employee.Employee_ID"
              label="Trial Period End Date"
              v-model="trialPeriodEndDate"
              readonly
            ></v-text-field>
            <DatePicker
              v-if="editMode && employee.Employee_ID"
              v-model="leftDate"
              label="Left Date"
              clearable
              outlined
            />
            <v-text-field
              v-if="employee.Employee_ID && !editMode"
              label="Left Date"
              v-model="leftDate"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="3" lg="2">
        <h3>Work Agreement Info</h3>
        <div>
          <v-select
            v-if="editMode"
            :items="contractTypes"
            v-model="employee.Contract_Type_Code"
            item-text="Description"
            item-value="Code"
          ></v-select>
          <v-text-field
            v-else
            label="Contract Type"
            v-model="employee.Contract_Type"
            readonly
          ></v-text-field>
        </div>
        <div>
          <v-select
            v-if="editMode"
            :items="workLocations"
            item-value="Code"
            item-text="Description"
            v-model="employee.Work_Location_Type_Code"
          ></v-select>
          <v-text-field
            v-else
            label="Work Location"
            v-model="employee.Work_Location_Type"
            readonly
          ></v-text-field>
        </div>
          <v-select
            v-if="editMode"
            label="Department"
            :items="departments"
            v-model="employee.Dep_ID"
            item-text="Dep_Name"
            item-value="Dep_ID"
            @change="onDepartmentChange"
          ></v-select>
          <v-text-field
            v-else
            label="Department"
            v-model="employee.Department"
            readonly
          ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" lg="2" class="d-flex flex-column" v-if="canViewEnglishLevel">
        <h3>English Level</h3>
        <div>
          <v-text-field
            v-if="employee.Employee_ID && !editMode"
            label="English Level"
            v-model="employeeEnglishLevel.Dev_Skills_Subcategory_Description"
            readonly
          ></v-text-field>
          <v-select
            v-else-if="employee.Employee_ID && editMode"
            label="English Level"
            v-model="employeeEnglishLevel"
            :items="englishLevels"
            item-text="Dev_Skills_Subcategory_Description"
            item-value="Dev_Skills_Subcategory_ID"
            return-object
          ></v-select>
        </div>
        <div>
          <v-textarea
            label="Level Confirmed By"
            v-model="employee.Confirmed_English_Level"
            rows="1"
            auto-grow
            :readonly="!editMode"
          ></v-textarea>
        </div>
        <div v-if="hasPermissionRate">
          <v-text-field
            v-if="employee.Employee_ID"
            label="Rate"
            value="Click on details"
            readonly
          >
            <template v-slot:append>
              <v-btn
                text
                plain
                small
                color="primary"
                :disabled="((officeManager || executiveAssistant) && (currentEmployee && editMode))"
                @click="onRateDetailsClick"
              >
                Details...
              </v-btn>
            </template>
          </v-text-field>
        </div>
      </v-col>
      <v-col cols="12" md="3" lg="2" class="d-flex flex-column">
        <h3>Notes</h3>
        <div>
          <v-textarea
            label="Public Notes"
            v-model="publicNotes"
            rows="1"
            auto-grow
            :readonly="!editMode"
          ></v-textarea>
        </div>
        <div v-if="currentEmployeeRoles.financier.val || currentEmployeeRoles.hr.val">
          <v-textarea
            label="HR Notes"
            v-model="hrNotes"
            rows="1"
            auto-grow
            :readonly="!editMode"
          ></v-textarea>
        </div>
        <div v-if="employee.Is_Deleted">
          <v-textarea
            label="Deleted Notes"
            v-model="employee.Deleted_Notes"
            rows="1"
            auto-grow
            :readonly="!editMode"
          ></v-textarea>
        </div>
      </v-col>
      <v-row class="px-4" v-if="employee.Employee_ID">
        <v-spacer></v-spacer>
        <v-col cols="auto" class="d-flex flex-wrap pt-0 px-4">
          <v-switch
            dense
            hide-details
            :disabled="!changeRolesDisable"
            class="ma-2"
            v-for="(role, roleKey) of employeeRoles"
            :key="roleKey"
            :label="role.name"
            v-model="role.val"
            @change="changeEmployeeRole($event, role.name)"
          >
          </v-switch>
        </v-col>
      </v-row>
      </v-row>
    <div v-if="value">
      <StatusHistory
        v-model="showStatusHistory"
        :canEdit="editMode"
        :employee="employee"
      />
      <RateHistory
        v-model="showRate"
        :canEdit="editMode"
        :employee="employee"
      />
      </div>
  </div>
</template>
<script>
export default {
  name: 'EmployeeProfile',
  components: {
    DatePicker: () => import('@/components/global/DatePicker.vue'),
    StatusHistory: () => import('@/components/employee/StatusHistory.vue'),
    RateHistory: () => import('@/components/employee/RateHistory.vue')
  },
  props: {
    value: {
      required: false
    },
    editMode: {
      required: true,
      default: false
    },
    hasPermissionRate: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showStatusHistory: false,
      showRate: false,
      searchEmployee: '',
      englishLevels: [],
      employeeRoles: {
        financier: {
          val: false,
          name: 'Financier'
        },
        hr: {
          val: false,
          name: 'HR'
        },
        manager: {
          val: false,
          name: 'Manager'
        },
        assets_manager: {
          val: false,
          name: 'Assets Manager'
        }
      },
      rules: {
        required: [v => !!v || 'Required'],
        noSpaces: [v => (v || '').indexOf(' ') < 0 || 'No spaces are allowed']
      }
    }
  },
  computed: {
    changeRolesDisable () {
      return this.editMode && this.currentEmployeeRoles.financier.val
    },
    employee: {
      get () {
        return this.value
      },
      set () {
        this.$emit('input', this.value)
      }
    },
    employeeEnglishLevel: {
      get () {
        return {
          Dev_Skills_Subcategory_Description: this.employee.Dev_Skills_Subcategory_Description,
          Dev_Skills_Subcategory_ID: this.employee.Dev_Skills_Subcategory_ID
        }
      },
      set (val) {
        this.employee.Dev_Skills_Subcategory_Description = val.Dev_Skills_Subcategory_Description
        this.employee.Dev_Skills_Subcategory_ID = val.Dev_Skills_Subcategory_ID
        this.updateEmplEnglishLevel()
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    currentEmployeeRoles () {
      return this.$store.getters.getEmployeeRoles
    },
    employeeList () {
      const r = new RegExp(this.searchEmployee, 'gi')
      return this.$store.getters.getEmployee.filter(item => {
        r.lastIndex = 0
        return r.test(item.full_name) || this.employee.Supervisor_ID === item.employee_id
      })
    },
    contractTypes () {
      return this.$store.getters.getContractTypes
    },
    workLocations () {
      return this.$store.getters.getWorkLocations
    },
    departments () {
      return this.$store.getters.getDepartments
    },
    publicNotes: {
      get () {
        let res = ''
        if (this.employee.PublicNotes) {
          res = this.employee.PublicNotes.replace(/\\par[d]?/g, '')
        }
        return res.replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, '').trim()
      },
      set (val) {
        const plain = val.replace(/\n/g, '\\par\n')
        this.employee.PublicNotes = '{\\rtf1\\ansi\\ansicpg1252\\deff0\\deflang2057{\\fonttbl{\\f0\\fnil\\fcharset0 Microsoft Sans Serif;}}\n\\viewkind4\\uc1\\pard\\f0\\fs17 ' + plain + '\\par\n}'
      }
    },
    hrNotes: {
      get () {
        let res = ''
        if (this.employee.HRNotes) {
          res = this.employee.HRNotes.replace(/\\par[d]?/g, '')
        }
        return res.replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, '').trim()
      },
      set (val) {
        const plain = val.replace(/\n/g, '\\par\n')
        this.employee.HRNotes = '{\\rtf1\\ansi\\ansicpg1252\\deff0\\deflang2057{\\fonttbl{\\f0\\fnil\\fcharset0 Microsoft Sans Serif;}}\n\\viewkind4\\uc1\\pard\\f0\\fs17 ' + plain + '\\par\n}'
      }
    },
    status: {
      get () {
        return this.employee.Status === 'Status error' ? null : this.employee.Status
      },
      set (val) {
        if (val !== 'Status error') this.employee.Status = val
      }
    },
    hiringDate: {
      get () {
        return new Date(this.employee.Hiring_Date).toISOString().substr(0, 10)
      },
      set (val) {
        this.employee.Hiring_Date = val
      }
    },
    leftDate: {
      get () {
        if (this.employee.Left_Date) return new Date(this.employee.Left_Date).toISOString().substr(0, 10)
        return null
      },
      set (val) {
        this.employee.Left_Date = val
        return val
      }
    },
    trialPeriodEndDate: {
      get () {
        if (!this.employee.End_Of_Trial_Period_Date) return ''
        return new Date(this.employee.End_Of_Trial_Period_Date).toISOString().substr(0, 10)
      },
      set (val) {
        this.employee.End_Of_Trial_Period_Date = val || null
      }
    },
    canEdit () {
      return this.currentEmployeeRoles.hr.val || this.currentEmployeeRoles.financier.val
    },
    officeManager () {
      const position = this.$store.getters.getCurrentUserPosition
      return position === 'Office Manager' && this.currentEmployeeRoles.hr.val
    },
    currentEmployee () {
      return this.employee.Employee_ID === this.user.employee_id
    },
    executiveAssistant () {
      const position = this.$store.getters.getCurrentUserPosition
      return position === 'Executive Assistant' && this.currentEmployeeRoles.hr.val
    },
    employeeAM () {
      const allEmployees = this.$store.getters.getAllEmployee
      if (!allEmployees || !Array.isArray(allEmployees)) return false
      const currentUserEmployee = allEmployees.find(item => item.Employee_ID === this.user.employee_id)
      if (!currentUserEmployee) return false
      return currentUserEmployee.Status === 'Account Manager (AM)'
    },
    employeePM () {
      const allEmployees = this.$store.getters.getAllEmployee
      if (!allEmployees || !Array.isArray(allEmployees)) return false
      const currentUserEmployee = allEmployees.find(item => item.Employee_ID === this.user.employee_id)
      if (!currentUserEmployee) return false
      const pmStatuses = ['Project Manager (PM)', 'PM', 'Project Manager']
      return pmStatuses.some(status => currentUserEmployee.Status === status) && currentUserEmployee.Department === this.employee.Department
    },
    canViewEnglishLevel () {
      return this.currentEmployee || this.employeeAM || this.employeePM || this.currentEmployeeRoles.hr.val || this.currentEmployeeRoles.manager.val
    }
  },
  mounted () {
    if (this.employee) {
      for (const role in this.employeeRoles) {
        this.employeeRoles[role].val = false
      }
      if (this.employee.Employee_ID) {
        this.getRoles()
      }
      this.getUserPosition()
      this.getEnglishLevelsList()
    }
  },
  methods: {
    updateEmplEnglishLevel () {
      this.axios.post('/api/employee_english_skills', {
        subcategoryId: this.employee.Dev_Skills_Subcategory_ID,
        englishLevel: this.employee.Dev_Skills_Subcategory_Description,
        employeeId: this.employee.Employee_ID
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'English level successfuly saved' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getEnglishLevelsList () {
      this.axios.get('/api/employee_english_levels_list', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.englishLevels = result.data.map(item => {
          return {
            Dev_Skills_Subcategory_Description: item.Dev_Skills_Subcategory_Description,
            Dev_Skills_Subcategory_ID: item.Dev_Skills_Subcategory_ID
          }
        })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    saveTrialPeriodEndDate () {
      if (!this.employee.Employee_ID) {
        return
      }
      if (this.employee.Trial_Period_ID) {
        this.axios.put('/api/employee_trial_period', {
          End_Date: this.employee.End_Of_Trial_Period_Date,
          Trial_Period_ID: this.employee.Trial_Period_ID
        }, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(result => {
          this.$store.dispatch('setSuccess', { successMsg: 'Period successfully changed' })
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.axios.post('/api/employee_trial_period', {
          Employee_ID: this.employee.Employee_ID,
          End_Date: this.employee.End_Of_Trial_Period_Date
        }, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(result => {
          this.$store.dispatch('setSuccess', { successMsg: 'Period successfully changed' })
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      }
    },
    getRoles () {
      this.axios.get('/api/employee_role/' + this.employee.Login, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        for (let i = 0; i < result.data.length; i++) {
          const role = result.data[i].RoleName.toLowerCase()
          if (this.employeeRoles[role]) {
            this.employeeRoles[role].val = true
          }
        }
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    changeEmployeeRole (e, key) {
      const reqObj = {
        UserName: this.employee.Login,
        MarketingRole: 'DONOTCHANGE',
        FinancierRole: 'DONOTCHANGE',
        QARole: 'DONOTCHANGE',
        ManagerRole: 'DONOTCHANGE',
        HRRole: 'DONOTCHANGE',
        AssetsManagerRole: 'DONOTCHANGE'
      }
      reqObj[`${key.replace(/ /gi, '')}Role`] = e ? key.replace(/ /gi, '_').toLowerCase() : ''
      this.axios.post('/api/employee_role', reqObj, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.$store.dispatch('setSuccess', { successMsg: 'Role successfully updated' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    onDepartmentChange (selectedDepId) {
      const selectedDepartment = this.departments.find(dep => dep.Dep_ID === selectedDepId)
      this.employee.OldDepartment = this.employee.Department
      this.employee.Department = selectedDepartment ? selectedDepartment.Dep_Name : ''
    },
    onRateDetailsClick () {
      if (this.hasPermissionRate) {
        this.axios.get(`/api/employee_rate/${this.employee.Employee_ID}`, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.$store.dispatch('setEmployeeRate', { rate: res.data, employeeId: this.employee.Employee_ID })
          this.showRate = true
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      }
    },
    getUserPosition () {
      this.axios.get(`/api/get_user_position/${this.user.employee_id}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setCurrentUserPosition', { employeePosition: response.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  }
}
</script>
